// extracted by mini-css-extract-plugin
export default {"content":"ProjectAlgaeKitPage_content__7w14-"};